import React from 'react';
import { useSearchResults, useSearchQuestion } from '@context/DataContext';
import useLocalStorage, { getValue } from '@hooks/useLocalStorage';

const PeerCardSave = ({ data, setDisplay }) => {
  const { localStorageKey, resultTab, tabNames } = useSearchResults();
  const { setTab } = useSearchQuestion();
  const [items, setItems] = useLocalStorage(localStorageKey, []);

  const getIndex = (_items) => {
    return typeof _items === 'undefined' ? -1 : _items.findIndex((i) => i.id === data.id);
  };

  let index = getIndex(items);

  const toggleSave = () => {
    // add or remove from local storage
    let items = getValue(localStorageKey);
    items = typeof items === 'undefined' ? [] : items;
    index = getIndex(items);

    index > -1 ? items.splice(index, 1) : items.push(data);
    setItems([...items]);

    // set display state of card to false if we toggle from favorites tab (unsave)
    setDisplay(resultTab != 'saved');

    // rerender
    if (resultTab === tabNames.saved && !items.length) setTab(tabNames.saved);
  };

  return (
    <div className="peer-cards__save">
      <button 
        className="card-summary-item__save-link" 
        onClick={() => toggleSave()}
        aria-pressed={index > -1 ? 'true' : 'false'}>
          <svg className="sprite-icon card-summary-item__icon card-summary-item__icon--bookmark">
            <use href={`#icon-bookmark${index > -1 ? '-saved' : ''}`}></use>
          </svg>      
          {index > -1 ? 'Saved' : 'Save'}
      </button>
    </div>
  );
};
export default PeerCardSave;
